import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/home/Nav";
import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/home/Marquee";
import { Manifesto } from "@/components/home/Manifesto";
import { Assurance } from "@/components/home/Assurance";
import { Collection } from "@/components/home/Collection";
import { Transport } from "@/components/home/Transport";
import { Archive } from "@/components/home/Archive";
import { Graduates } from "@/components/home/Graduates";
import { VipCapture } from "@/components/home/VipCapture";
import { Footer } from "@/components/home/Footer";

export default function Home() {
  useLenis();
  const [content, setContent] = useState({ graduates: [], archive: [] });
  useEffect(() => { api.get("/content").then((r) => setContent(r.data)).catch(() => {}); }, []);

  return (
    <main className="bg-[#0B1630] text-[#F8F6F0]" data-testid="home-page">
      <Nav />
      <Hero auctionDate={content.auction_date} />
      {content.graduates.length > 0 && <Marquee items={content.graduates} testId="graduate-marquee" />}
      <Manifesto />
      <Graduates graduates={content.graduates} />
      <Assurance />
      <Collection />
      <Transport />
      <Archive archive={content.archive} />
      <VipCapture />
      <Footer />
    </main>
  );
}
